<template>
  <div class="flex flex-col">
    <div class="my-3 overflow-x-auto table-content">
      <LoaderInside loader v-if="loader"></LoaderInside>
      <div v-else>
        <table class="w-full">
          <thead>
          <tr class="bg-headerTable">
            <th v-if="rowSelection">
              <input type="checkbox" :checked="selectAll" @change="selectAllRows()">
            </th>
            <th scope="col" class="px-3 py-1.5 bg-headerTable text-xs"
                v-for="(row, index) in aux_fields" :key="index" :class="row.thclass?row.thclass:'text-left'">
              {{ row.label ? limpiarTexto(row.label) : limpiarTexto(row) }}
            </th>
          </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
          <tr v-if="items.length===0">
            <td class="py-1" :colspan="aux_fields.length">
              <slot name="table-empty">
                <p class="text-center">{{ tableEmptyMessage }}</p>
              </slot>
            </td>
          </tr>
          <tr v-for="(item, index) in items" :key="index" class="hover:bg-blue-100">
            {{ agregarIndex(item, index) }}
            <td class="text-center" v-if="rowSelection">
              <input type="checkbox" :checked="item.check" @change="selectRow(item.check, index)">
            </td>
            <td class="px-1 py-1 text-xs" v-for="(row, key) in aux_fields" :key="key"
                :class="row.class ? row.class: 'whitespace-nowrap'">
                <span v-if="!row.key && row==='n'">
                  {{ ++index }}
                </span>
              <slot :name="row.key?row.key:row" v-bind:item="item">
                {{ row.key ? item[row.key] : item[row] }}
              </slot>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderInside from "./LoaderInside";
export default {
  name: "tablecomponent",
  components: {LoaderInside},
  props: {
    fields: {
      type: Array,
      default: Array
    },
    items: {
      type: Array,
      default: []
    },
    showIndex: false,
    tableEmptyMessage: {
      type: String,
      default: 'No hay datos'
    },
    rowSelection: {
      type: Boolean,
      default: false
    },
    loader: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    aux_fields: [],
    selectAll: false
  }),
  methods: {
    limpiarTexto(text) {
      return text.replace(/_/g, ' ')
    },
    agregarIndex(item, index) {
      item.index = index
    },
    async selectAllRows() {
      if (this.rowSelection) {
        this.selectAll = !this.selectAll
        await Promise.all(this.items.map(async (item, index) => {
          this.items[index].check = this.selectAll
        }));
        this.$emit('selectedRows', this.items.filter(item => item.check === true))
      }
    },
    async selectRow(check, index) {
      this.items[index].check = !check
      this.$emit('selectedRows', this.items.filter(item => item.check === true))
    },
    startComponent(){
      if (Array.isArray(this.fields) && this.fields.length > 0) {
        this.aux_fields = this.fields
      } else {
        if (this.fields.length <= 0)
          this.aux_fields = Object.keys(this.items[0])
      }

      if (this.showIndex)
        this.aux_fields.unshift('n')
    }
  },
  mounted() {
    this.startComponent()
  },
  watch: {
    fields(){
      this.startComponent()
    },
    items() {
      if (this.fields.length <= 0) {
        this.aux_fields = Object.keys(this.items[0])
      }
      if (!this.selectAll) {
        if (this.rowSelection) {
          this.items.forEach(function (e) {
            e.check = false
          })
        }
      }
    },
  }
}
</script>

<style lang="scss">
.table-content::-webkit-scrollbar {
  height: .5rem;
}

.table-content::-webkit-scrollbar-track {
  @apply bg-gob;
}

.table-content::-webkit-scrollbar-thumb {
  @apply bg-gob;
  border-radius: .25rem;

  &:active {
    @apply bg-gray-500;
  }
}

.max-table-height {
  max-height: 70vh;
}
</style>
